import { render, staticRenderFns } from "./transferredModal.vue?vue&type=template&id=b9388e98&scoped=true&"
import script from "./transferredModal.vue?vue&type=script&lang=js&"
export * from "./transferredModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9388e98",
  null
  
)

export default component.exports